import { render, staticRenderFns } from "./ReceiptItems.vue?vue&type=template&id=57df288e"
import script from "./ReceiptItems.vue?vue&type=script&lang=js"
export * from "./ReceiptItems.vue?vue&type=script&lang=js"
import style0 from "./ReceiptItems.vue?vue&type=style&index=0&id=57df288e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports